import React, { Component, PropTypes } from 'react';
import $ from 'jquery';
import { assetAt } from 'utils/assets';

class ProductTraceabilityItem extends Component {
  constructor(props) {
    super(props);

    this.duplicateProduct = this.duplicateProduct.bind(this);
    this.deleteProduct = this.deleteProduct.bind(this);
    this.changeProductDlu = this.changeProductDlu.bind(this);
    this.changeProductBatch = this.changeProductBatch.bind(this);
  }

  componentDidMount() {
    const selector = `#dlu${this.props.product.id}`;
    $(selector)
      .datepicker({
        language: 'fr',
        autoclose: true,
        orientation: 'auto',
        minViewMode: 1,
        format: 'mm/yyyy',
        immediateUpdates: true,
      })
      .on('changeDate', evt => {
        this.changeProductDlu(evt);
      });
  }

  duplicateProduct(evt) {
    this.props.onDuplicate({ ...this.props.product, new: true });
  }

  deleteProduct(evt) {
    this.props.onDelete(this.props.product);
  }

  changeProductDlu(evt) {
    this.props.onChange({ ...this.props.product, dlu: evt.target.value });
  }

  changeProductBatch(evt) {
    this.props.onChange({ ...this.props.product, batch: evt.target.value });
  }

  render() {
    const { product } = this.props;

    const emptyBatchDisplay = product.isTraceable ? 'NR' : 'NC';

    const emptyDLUDisplay = product.isTraceable ? 'NR' : 'NC';

    const computedBatchClassName = product.isTraceable
      ? 'ui input'
      : 'ui input disabled';

    const computedDLUClassName = product.isTraceable
      ? 'datepicker'
      : 'ui input disabled';

    return (
      <tr>
        <td>{product.name}</td>
        <td>{product.active_substance}</td>
        <td>
          <input
            type="text"
            className={computedBatchClassName}
            onChange={this.changeProductBatch}
            value={product.batch || emptyBatchDisplay}
            disabled={!product.isTraceable}
          />
        </td>
        <td>
          <input
            type="text"
            id={`dlu${product.id}`}
            className={computedDLUClassName}
            onChange={this.changeProductDlu}
            value={product.dlu || emptyDLUDisplay}
            disabled={!product.isTraceable}
          />
        </td>
        <td>
          {product.quick_fds && (
            <a href={product.quick_fds} target="_blank noopener noreferer">
              <img
                src={assetAt('images/logo_quickfds.png')}
                alt="quickfds"
                width="50"
              />
            </a>
          )}
        </td>
        <td>
          <div className="ui buttons">
            <button
              className="ui icon button"
              type="button"
              onClick={this.duplicateProduct}
            >
              <i className="add icon" />
            </button>
            {product.duplicate && (
              <button
                className="ui red icon button"
                type="button"
                onClick={this.deleteProduct}
              >
                <i className="remove icon" />
              </button>
            )}
          </div>
        </td>
      </tr>
    );
  }
}

ProductTraceabilityItem.propTypes = {
  product: PropTypes.object.isRequired,
  onDuplicate: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default ProductTraceabilityItem;



// WEBPACK FOOTER //
// ./src/modules/saas/pco/interventions/components/ProductTraceabilityItem.js